import { toSlug } from '../utils/slug';
import { REF_QUERY_PARAM, REF_RELATED_SEARCH } from '../../constants';

// Hardcoded high-value search terms, curated from real search volume (searchTerms
// collection). Links point at the Cloudflare-served static ISR pages (/search/{slug},
// see docs/seo-lazy-isr-design.md), giving Google a crawl path into them without
// waiting for sitemap pickup. If a term hasn't been published to KV yet, the Worker
// 302-redirects to the live SPA search - never a dead end.
const POPULAR_SEARCH_TERMS = [
  'Melitta Solo',
  'Sage Bambino Plus',
  'Sage Barista Pro',
  'Breville Bambino Plus',
  'Lelit Elizabeth',
  'Lelit Anna',
  'Eureka Mignon Specialita',
  'DeLonghi Dedica Style EC685',
  'DeLonghi Rivelia',
  'Ninja Luxe Cafe',
];

export default function PopularSearches() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-8 text-center" aria-label="חיפושים פופולריים">
      <h2 className="text-lg font-semibold text-white mb-3">חיפושים פופולריים</h2>
      <ul className="flex flex-wrap justify-center gap-2">
        {POPULAR_SEARCH_TERMS.map((term) => (
          <li key={term}>
            <a
              href={`/search/${toSlug(term)}?${REF_QUERY_PARAM}=${REF_RELATED_SEARCH}`}
              className="inline-block px-3 py-1.5 rounded-full bg-white/10 !text-white text-sm hover:bg-white/20 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50"
            >
              {term}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
